// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Keyboard.css */
.keyboard-container {
  margin: auto;
  position: fixed;
  bottom: 0;
  width: 98%;
  background-color: #f8f8f8;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
}

.keyboard-row {
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}

.key {
  background-color: #ffffff;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  margin: 2px;
  padding: 10px 8px;
  font-size: 18px;
  cursor: pointer;
  flex: 1 1;
  max-width: 40px;
  text-align: center;
}

.key:hover {
  background-color: #e0e0e0;
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Crossword/PublicCrossword/Keyboard/Keyboard.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,SAAO;EACP,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Keyboard.css */\n.keyboard-container {\n  margin: auto;\n  position: fixed;\n  bottom: 0;\n  width: 98%;\n  background-color: #f8f8f8;\n  border-top: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n}\n\n.keyboard-row {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 5px;\n}\n\n.key {\n  background-color: #ffffff;\n  border: 1px solid #d0d0d0;\n  border-radius: 4px;\n  margin: 2px;\n  padding: 10px 8px;\n  font-size: 18px;\n  cursor: pointer;\n  flex: 1;\n  max-width: 40px;\n  text-align: center;\n}\n\n.key:hover {\n  background-color: #e0e0e0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
